import { render, staticRenderFns } from "./EventsThumb.vue?vue&type=template&id=4e6542a8&scoped=true&"
import script from "./EventsThumb.vue?vue&type=script&lang=js&"
export * from "./EventsThumb.vue?vue&type=script&lang=js&"
import style0 from "./EventsThumb.vue?vue&type=style&index=0&id=4e6542a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6542a8",
  null
  
)

export default component.exports